import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {calculatedEntriesInitialState, resetEntriesData} from './data';
import {
  PlanningPeriodFilter,
  ProductionCostEntryStatus,
  ProductionCostEntryOrigin
} from './types';

const calculatedEntriesSlice = createSlice({
  name: 'calculated-entries',
  initialState: calculatedEntriesInitialState,
  reducers: {
    receivedProductionCostEntries: (state, {payload}) => {
      const {
        page,
        paginationOutput,
        entries,
        subtotals,
        absoluteValuesSubtotals,
        absoluteValuesEntries
      } = payload;

      return {
        ...state,
        subtotals,
        absoluteValuesSubtotals,
        page: page,
        paginationOutput,
        entries,
        isReloadData: false,
        absoluteValuesEntries: absoluteValuesEntries
          ? absoluteValuesEntries
          : []
      };
    },
    productionCostEntryWasRemoved: state => {
      return {
        ...state,
        page:
          state.entries.length === 1 && state.page > 0 // delete when only one entry exists on page > 0
            ? state.page - 1
            : state.page,
        isReloadData: true
      };
    },
    productionCostEntryWasCloned: state => {
      return {
        ...state,
        isReloadData: true,
        page: 0
      };
    },
    productionCostEntryWasUpdated: state => {
      return {
        ...state,
        isReloadData: true,
        page: 0
      };
    },
    updateFilter: (
      state,
      {
        payload
      }: PayloadAction<{
        field: string;
        value:
          | string[]
          | string
          | PlanningPeriodFilter
          | ProductionCostEntryStatus[]
          | ProductionCostEntryOrigin[];
      }>
    ) => {
      return {
        ...state,
        ...resetEntriesData,
        filters: {
          ...state.filters,
          [payload.field]: payload.value
        }
      };
    },
    toggleAnalyticsMode: (state, {payload: analyticsModeType}) => {
      if (analyticsModeType === state.analyticsModeType) return state;
      return {
        ...state,
        analyticsMode: analyticsModeType !== 'OVERVIEW',
        analyticsModeType: analyticsModeType
      };
    },
    resetDataTableEntries: state => {
      return {
        ...state,
        ...resetEntriesData
      };
    }
  }
});

export const {
  receivedProductionCostEntries,
  productionCostEntryWasRemoved,
  productionCostEntryWasCloned,
  productionCostEntryWasUpdated,
  updateFilter,
  toggleAnalyticsMode,
  resetDataTableEntries
} = calculatedEntriesSlice.actions;

export default calculatedEntriesSlice.reducer;
